// client/src/routes/app/insurance/index.tsx — SCR-INS-001 „Asigurări" · MAINT-009 (04 §8.9,
// §9.2.3).
//
// Replaces UI-003's `PlaceholderScreen`, which named MAINT-005 as its owner; MAINT-005 shipped
// the endpoints and D-1106 handed the screen to this item.
//
// `Operations.Read` is the gate `InsurancesEndpoints` puts on every one of its routes, so the
// sidebar hides the entry and a typed URL meets SCR-SYS-403 rather than a screen full of 403s
// (§6.2, §9.2.2). The property filter and the PAD banner additionally need `Portfolio.Read`,
// which is a SEPARATE code (03 §17.1): those are gated inside, so a membership narrowed to
// operations gets the register without them instead of an error.
//
// The filters, the paging, which of the two renderings is showing and every control of the
// compliance calendar are Zod-validated search params (§9.2.3) — `features/insurance/search.ts`
// spreads the calendar's own schema into this one, so the calendar can be re-homed onto
// SCR-FISC-002 by spreading the same object there (D-1132).
//
// THE FISCAL SLOT IS ASSEMBLED HERE, and this is the only file in the app that imports both
// `features/compliance-calendar` and `features/fiscal`. Neither of those two may import the
// other — the calendar would stop being re-homable and the fiscal module would gain a
// dependency on an insurance screen — so the route is where they meet, which is also the file
// that moves when SCR-FISC-002 takes the calendar over. `fiscalCalendarQuery` is the calendar's
// OWN window expressed as the fiscal endpoint's filters, so the slot and the lane inside the
// calendar share one query key and therefore one request (D-1073).

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { fiscalCalendarQuery } from '@/features/compliance-calendar/queries';
import { FiscalComplianceSlot } from '@/features/fiscal/FiscalComplianceSlot';
import { InsuranceRegister } from '@/features/insurance/InsuranceRegister';
import { insuranceSearchSchema, type InsuranceSearch } from '@/features/insurance/search';
import { todayInBucharest } from '@/features/payments/today';

export const Route = createFileRoute('/app/insurance/')({
  validateSearch: insuranceSearchSchema,
  component: InsuranceScreen,
});

function InsuranceScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Operations.Read">
      <InsuranceRegister
        search={search}
        onSearchChange={(next: (previous: InsuranceSearch) => InsuranceSearch) => {
          void navigate({ search: next });
        }}
        fiscalSlot={<FiscalComplianceSlot query={fiscalCalendarQuery(search, todayInBucharest())} />}
      />
    </RequirePermission>
  );
}
